import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-content" }
const _hoisted_2 = { class: "add-button" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "page" }
const _hoisted_5 = ["src"]

import { nextTick, onMounted, reactive, Reactive, ref, Ref } from 'vue';
import Pagination from '../Pagination.vue';
import { Action, FormType } from '@/typeDefine/CommonTypes';
import { Images, Product, ProductTypes } from '@/typeDefine/EntityType';
import { Api } from '@/http/Api';
import { BaseResponse, GetProductsResponse, GetProductTypesResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { ResponseCode } from '@/http/ResponseCode';
import { ElMessage, ElMessageBox, FormInstance, FormRules, UploadFile, UploadFiles, UploadProps, UploadRawFile, UploadUserFile } from 'element-plus';
import Editor, { EditorComponentType } from './Editor.vue';
import { Loading } from '@/util/Loading';
import { ConstantField } from '@/constant/ConstantField';
import { AddProductRequest } from '@/typeDefine/HttpRequestType';

interface ProductExtend extends Product {
    typeTags?: string[]
}

//当前页

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductManage',
  setup(__props) {

const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
//总页数
const totalPage: Ref<number> = ref(0)

const tableData: Ref<ProductExtend[]> = ref([])

const types: Ref<ProductTypes[]> = ref([])

const isOpendrawer: Ref<boolean> = ref(false)

const disabled: Ref<boolean> = ref(false)

const ruleFormRef: Ref<FormInstance | undefined> = ref()

//当前表单状态
const formType: Ref<FormType> = ref('none')

//当前选中的产品行id
const currentClickId: Ref<number> = ref(0)

const ruleForm: Reactive<AddProductRequest> = reactive({
    name: '',
    describeText: '',
    content: '',
    hot: 0,
    cover: '',
    images: [],
    typeId: [],
})

//上传的产品图列表
const productImageList: Ref<UploadUserFile[]> = ref([])

/**
* 富文本相关字段
*/
const editorRef: Ref<EditorComponentType | null> = ref(null)
const valueHtml: Ref<string> = ref('')

const rules: Reactive<FormRules<AddProductRequest>> = reactive({
    name: [
        {
            required: true, message: '请输入标题', trigger: 'blur',
        },
        {
            max: 255, message: '最大输入255个字符', trigger: 'blur'
        }
    ],
    describeText: [
        {
            max: 500, message: '最大输入500个字符', trigger: 'blur'
        }
    ],
    content: [
        {
            required: true, message: '请输入内容', trigger: 'blur',
        },
    ],
    cover: [
        {
            required: true, message: '请上传一张产品封面', trigger: 'blur',
        }
    ],
    typeId: [
        {
            required: true, message: '请选择产品类别', trigger: 'blur',
        }
    ]
})

onMounted(() => {
    requestProductTypes()
    requestProduct(currentPage.value)
})

//请求所有类别
const requestProductTypes: Action = async () => {
    const response: GetProductTypesResponse = await Api.instance.getProductTypes()

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        types.value = response.data.treeType
    }
}

//请求所有产品
const requestProduct: Action<[number]> = async (startPage: number) => {
    const response: GetProductsResponse = await Api.instance.getProductByPage({
        startPage
    })

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        tableData.value = response.data.products
        totalPage.value = response.data.totalPage

        let i: number = 0
        tableData.value = tableData.value.map(item => {
            return {
                order: ++i,
                ...item,
                typeTags: useProductTypePath(types.value,item.productType,item => item.name)
            }
        })
    }
}

//设置表单值
const setFormValue: Action<[AddProductRequest, UploadUserFile[], Action<[string?]>, string?]> = ({ name, describeText, content, hot, cover, typeId, images }, imageList,callback,param) => {
    ruleForm.name = name
    ruleForm.describeText = describeText
    ruleForm.content = content
    ruleForm.hot = hot
    ruleForm.cover = cover
    ruleForm.typeId = typeId
    ruleForm.images = images

    productImageList.value = imageList

    callback(param)
}

function useProductTypePath<T>(
  types: ProductTypes[],
  target: ProductTypes,
  mapper: (item: ProductTypes) => T
): T[] {
  for (const item of types) {
    if (item.id === target.parentId) {
      return [mapper(item), mapper(target)]
    }

    if (Array.isArray(item.children) && item.children.length > 0) {
      const childPath = useProductTypePath(item.children, target, mapper)
      if (childPath.length > 0) {
        return [mapper(item), ...childPath]
      }
    }
  }
  return []
}

const add: Action = () => {
    isOpendrawer.value = true
    formType.value = 'add'

    setFormValue({name: '', describeText: '', content: '',hot: 0, cover: '',typeId: [], images: []},[],() => {
        editorRef.value?.clear()
    })
}

const pageChange: Action<[number]> = (value: number) => {
    requestProduct(value)
}

//上传图片前校验
const beforeImageUpload: UploadProps['beforeUpload'] = (rawFile) => {
    if (!rawFile.type.startsWith("image")) {
        ElMessage.error('请上传图片类型文件')
        return false
    }

    Loading.instance.open('上传中...')
    return true
}

//上传失败
const onUploadError: UploadProps['onError'] = (error) => {
    Loading.instance.close()
    ElMessage.error(error.message)
}

//封面上传成功
const handleCoverUploadSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {
    Loading.instance.close()

    ruleForm.cover = response.data.images[0].path
}

//其他图片上传成功
const handleImagesUploadSuccess: UploadProps['onSuccess'] = (response: any, uploadFile) => {
    Loading.instance.close()

    for (const item of response.data.images) {
        ruleForm.images.push(item.id)
    }

}

//移除图片
const handleRemoveImage: UploadProps['onRemove'] = (uploadFile: UploadFile, uploadFiles: UploadFiles) => {
    //同步删除ruleForm.images中的图片id
    if (uploadFile.response) {
        const response: any = uploadFile.response

        const index: number = ruleForm.images.findIndex(item => item === response.data.images[0].id)

        if (index > -1) {
            ruleForm.images.splice(index, 1)
        }
    }else if(uploadFiles.every(item => item.name)) {
        ruleForm.images = uploadFiles.map(item => Number(item.name))
    }
}

//监听富文本的文字
const onChange: Action<[string]> = (value: string) => {
    ruleForm.content = value
}

const refresh: Action = () => {
    currentPage.value = 1
    requestProduct(currentPage.value)
}

//提交
const submitForm: Action<[FormInstance | undefined]> = async (formEl) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {

        if (!valid) {
            return
        }

        const { name, describeText, hot, cover, images, typeId } = ruleForm
        const response: BaseResponse = await Api.instance.addProduct({
            name,
            describeText,
            hot,
            cover,
            images,
            typeId,
            content: valueHtml.value
        })

        UtilMethods.showMessageToast(response)

        if (response.code === ResponseCode.OK) {
            refresh()
        }
    })
}

//打开更新窗口
const modifyProduct: Action<[number]> = (id: number) => {
    isOpendrawer.value = true
    formType.value = 'update'
    currentClickId.value = id

    const product: ProductExtend | undefined = tableData.value.find(item => item.id === id)

    if(!product) {
        return
    }

    const {name,describeText,content,hot,cover} = product

    setFormValue({
        name, describeText, content, hot, cover,
        typeId: useProductTypePath(types.value, product.productType,item => item.id), //productTypeIdRecursion(types.value, product.productType),
        images: product.images.map(item => item.id)
    },
        product.images.map(item => {
            return {
                name: `${item.id}`,
                url: `${item.path}`
            }
        }), () => {
            nextTick(() => {
                editorRef.value?.setHtml(product.content)
            })
        })
}

//更新
const onUpdateProductHandler: Action<[FormInstance | undefined]> = async (formEl) => {
    if (!formEl) return

    await formEl.validate(async (valid, fields) => {
        if (!valid) {
            return
        }
        const { name, content, describeText, cover, images, typeId, hot } = ruleForm

        const response: BaseResponse = await Api.instance.updateProduct({
            id: currentClickId.value,
            name,
            describeText,
            content: valueHtml.value,
            cover,
            hot,
            images,
            typeId
        })

        UtilMethods.showMessageToast(response)

        if (response.code === ResponseCode.OK) {
            refresh()
        }
    })
}

//删除
const onDeleteHandler: Action<[number]> = async (id) => {
    ElMessageBox.confirm('将执行删除该产品操作,是否确定?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(async () => {
        const response: BaseResponse = await Api.instance.deleteProduct({
            id,
        })

        UtilMethods.showMessageToast(response)

        if (response.code === ResponseCode.OK) {
            refresh()
        }
    }).catch(() => { })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("新增产品")
          ])),
          _: 1,
          __: [10]
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "产品管理", -1)),
        _createVNode(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "order",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "产品名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cover",
              label: "封面"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_image, {
                  "preview-teleported": "",
                  src: `${row.cover}`,
                  "preview-src-list": [`${row.cover}`]
                }, null, 8, ["src", "preview-src-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "describeText",
              label: "产品描述"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cover",
              label: "产品类型"
            }, {
              default: _withCtx(({ row }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.typeTags, (item) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: item,
                    class: "margin-left-5"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "cover",
              label: "是否属于热卖产品"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_switch, {
                  modelValue: row.hot,
                  "onUpdate:modelValue": ($event: any) => ((row.hot) = $event),
                  "inline-prompt": "",
                  "active-text": "是",
                  "inactive-text": "否",
                  "active-value": 1,
                  "inactive-value": 0,
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "发布时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "updateTime",
              label: "更新时间"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  onClick: ($event: any) => (modifyProduct(row.id))
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("修改")
                  ])),
                  _: 2,
                  __: [11]
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  onClick: ($event: any) => (onDeleteHandler(row.id))
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode(" 删除 ")
                  ])),
                  _: 2,
                  __: [12]
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Pagination, {
          "page-size": pageSize.value,
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          "total-page": totalPage.value,
          onCurrentPageChange: pageChange
        }, null, 8, ["page-size", "current-page", "total-page"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: isOpendrawer.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isOpendrawer).value = $event)),
      title: "新增产品",
      size: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          style: {"max-width":"600px"},
          model: ruleForm,
          rules: disabled.value ? null : rules,
          "label-width": "auto",
          disabled: disabled.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "产品名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "产品描述",
              prop: "describeText"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.describeText,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.describeText) = $event)),
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "产品封面",
              prop: "cover"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: `${_unref(ConstantField).SERVER}/product/admin/uploadImages`,
                  "show-file-list": false,
                  "on-success": handleCoverUploadSuccess,
                  "before-upload": beforeImageUpload,
                  "on-error": onUploadError,
                  data: { imageType: 'productCover' },
                  "with-credentials": ""
                }, {
                  default: _withCtx(() => [
                    (ruleForm.cover)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: `${ruleForm.cover}`,
                          class: "avatar",
                          style: {"max-width":"178px","max-height":"178px"}
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "产品图片",
              prop: "images"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "file-list": productImageList.value,
                  "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((productImageList).value = $event)),
                  "before-upload": beforeImageUpload,
                  "on-error": onUploadError,
                  "on-success": handleImagesUploadSuccess,
                  "on-remove": handleRemoveImage,
                  action: `${_unref(ConstantField).SERVER}/product/admin/uploadImages`,
                  "list-type": "picture-card",
                  data: { imageType: 'productImages' },
                  "with-credentials": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "产品详情内容",
              prop: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(Editor, {
                  ref_key: "editorRef",
                  ref: editorRef,
                  "value-html": valueHtml.value,
                  "onUpdate:valueHtml": _cache[4] || (_cache[4] = ($event: any) => ((valueHtml).value = $event)),
                  mode: 'default',
                  placeholder: '请输入产品详细介绍内容',
                  onOnChange: onChange,
                  disabled: disabled.value
                }, null, 8, ["value-html", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "产品类别",
              prop: "typeId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: ruleForm.typeId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.typeId) = $event)),
                  options: types.value,
                  props: { label: 'name', value: 'id' },
                  placeholder: "请选择类别"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "是否为热卖产品",
              prop: "hot"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: ruleForm.hot,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.hot) = $event)),
                  "inline-prompt": "",
                  "active-text": "是",
                  "inactive-text": "否",
                  "active-value": 1,
                  "inactive-value": 0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                (formType.value === 'add')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode(" 提交 ")
                      ])),
                      _: 1,
                      __: [14]
                    }))
                  : (formType.value === 'update')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "success",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (onUpdateProductHandler(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode(" 更新 ")
                        ])),
                        _: 1,
                        __: [15]
                      }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})